import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ProjectService } from 'src/app/_services/project/project.service';
import { UserService } from 'src/app/_services/user/user.service';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { Router } from '@angular/router';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';

@Component({
  selector: 'app-myproject',
  templateUrl: './myproject.component.html',
  styleUrls: ['./myproject.component.scss']
})
export class MyprojectComponent implements OnInit {
  projectForm
  // row data and column definitions  
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any
  tenantId: string;
  currentUser: any;
  selectedFile: File;
  jsonData: any;
  users: any;
  userDetails: any;
  gridApi: any;
  gridColumnApi: any;
  form: FormGroup;
  gridLength = 0;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'
  projectId: any;
  isAdministrator: boolean = false;
  isManager: any;

  constructor(
    private userService: UserService,
    private projectService: ProjectService,  
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private storageService: LocalStorageService,
    private router: Router
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();  

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });
    
    this.projectForm = new FormGroup({
      customer: new FormControl(''),
      brand: new FormControl(''),
      currentModel: new FormControl(''),
      segment: new FormControl(''),
      projectCode: new FormControl(''),
      roughBudgetIndication: new FormControl(''),
      marketPositioning: new FormControl(''),
      platform: new FormControl(''),
      productionSites: new FormControl(''),
      lifecycles: new FormControl(''),
      lifecycleVolume: new FormControl(''),
      projectName: new FormControl(''),
      competitors: new FormControl(''),
      projectDescription: new FormControl(''),
      salesManager: new FormControl(''),
      quotationManager: new FormControl(''),
      projectManager: new FormControl(''),
      projectController: new FormControl(''),
      rfqDate: new FormControl(''),
      quotationDate: new FormControl(''),
      decisionDate: new FormControl(''),
      projectEnterMs: new FormControl(''),
      sop: new FormControl(''),
      eop: new FormControl(''),
      totalHours: new FormControl(''),
      remainingHours: new FormControl(''),
    })
    
   }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.isAdministrator = this.userDetails.roles.includes('RoleAdministrator');
    this.isManager = this.userDetails.roles.includes('RolePmoAdministrator');

     this.getUsers();
    this.getProjectsData();
    
  }

  getProjectsData() {
    if(this.isAdministrator){
      this.projectService.getProjects().subscribe((response: any) => {
          this.rowData = response;
        });
    } else{
      let ignoreArchived : boolean = false;
      this.projectService.getProjectByUserId(this.userDetails.id, ignoreArchived).subscribe((response: any) => {
        this.rowData = response;
      });
    }
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  updateProject() {
    let currentProjectId = this.selectedCheckboxData[0].id; 
    this.router.navigate([this.tenantId + '/dashboard/project/project-list/myparameters'], { queryParams: { projectID: currentProjectId } });
    if (this.projectId) {
      this.projectService.updateProject(this.projectId, this.projectForm.value).subscribe(response => {
        this.backToMyProject()
      }, error => {
        this.openSnackBar('ERROR: cannot update project: ' + error);
      })
    }
}


  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }  

  // create column definitions  
  private createColumnDefs() {
    return [
      {
        headerName: "Project Name",
        field: "projectName",
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: "Project Code",
        field: "projectCode",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Customer",
        field: "customer",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Project Manager",
        field: "projectManager",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Adas Level",
        field: "adasLevel",
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      }, 
      {
        headerName: "Total Hours",
        field: "totalHours",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      // {
      //   headerName: "Remaining Hours",
      //   valueGetter: function(params){
      //     if(params.data.remainingHours === null) {
      //         return 0;
      //     } else {
      //         return params.data.remainingHours;
      //     }
      //   },  
      //   field: "remainingHours",
      //   filter: true,
      //   editable: false,
      //   sortable: true,
      // },
      {
        headerName: "Start Date",
        field: "startDate",
        filter: true,
        editable: false,
        sortable: true,
        hide: false
      },
      {
        headerName: "End Date",
        field: "endDate",
        filter: true,
        editable: false,
        sortable: true,
        hide: false
      },
      {
        headerName: "% of Completion",
        field: "percentWorkCompleted",
        filter: true,
        editable: false,
        sortable: true,
        hide: false
      },
      // {
      //   headerName: "Project Completed",
      //   // field: "endDate",
      //   valueGetter: function(params){
      //     let percentValue : any;
      //     if(params.data.totalHours === null){
      //       percentValue = 0;
      //     }
      //     else {
      //       percentValue = ((params.data.totalHours - params.data.remainingHours) / params.data.totalHours) * 100;
      //       if(percentValue < 0){
      //         percentValue = 0
      //       }
      //       else{
      //         percentValue = Number(percentValue.toFixed(2));
      //       }
      //     }
      //     return percentValue + '%'
      //   },
      //   filter: true,
      //   editable: false,
      //   sortable: true,
      //   hide: false
      // },
      {
        headerName: "ProjectStatus",
        field: "projectStatus",
        cellStyle: (params) => {
         if (params.value === 'On hold' || params.value === 'On hold') {
            return { color: 'orange', 'font-weight': 'bold' };
          } else if (params.value === 'Active' || params.value === 'Active') {
            return { color: 'green', 'font-weight': 'bold' };
          } else if (params.value === 'Archive' || params.value === 'Archive') {
            return { color: 'red', 'font-weight': 'bold' };
          } 
          return null;
        },
        filter: true,
        editable: false,
        sortable: true,
      }, 
      {
        headerName: "Brand",
        field: "brand",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Created By",
        field: "createdBy",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Created Date Time",
        field: "createdDatetime",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Current Model",
        field: "currentModel",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Decision Date",
        field: "decisionDate",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Drive Train",
        field: "drivetrain",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      // {
      //   headerName: "Start Date",
      //   field: "startDate",
      //   filter: true,
      //   editable: false,
      //   sortable: true,
      //   hide: false
      // },
      // {
      //   headerName: "End Date",
      //   field: "endDate",
      //   filter: true,
      //   editable: false,
      //   sortable: true,
      //   hide: false
      // },
      // {
      //   headerName: "Project Completed",
      //   field: "endDate",
      //   filter: true,
      //   editable: false,
      //   sortable: true,
      //   hide: false
      // },
      {
        headerName: "EOP",
        field: "eop",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Has Rear Quarter Glass",
        field: "hasRearQuarterGlass",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "ID",
        field: "id",
        hide: true
      },
      {
        headerName: "Lifecycle Volume",
        field: "lifecycleVolume",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Lifecycles",
        field: "lifecycles",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Market",
        field: "market",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Market Positioning",
        field: "marketPositioning",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Model Year",
        field: "modelYear",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Modified By",
        field: "modifiedBy",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Modified Datetime",
        field: "modifiedDatetime",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Platform",
        field: "platform",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Production Sites",
        field: "productionSites",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Project Controller",
        field: "projectController",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Project Description",
        field: "projectDescription",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Project Enter Ms",
        field: "projectEnterMs",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Propulsion Type",
        field: "propulsionType",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Quotation Date",
        field: "quotationDate",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Quotation Manager",
        field: "quotationManager",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Rear End Configuration",
        field: "rearEndConfiguration",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "RFQ Date",
        field: "rfqDate",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Rough Budget Indication",
        field: "roughBudgetIndication",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Sales Manager",
        field: "salesManager",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Seat Capacity",
        field: "seatCapacity",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Seating Rows",
        field: "seatingRows",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Segment",
        field: "segment",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "SOP",
        field: "sop",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      // {
      //   headerName: "Start Date",
      //   field: "startDate",
      //   filter: true,
      //   editable: false,
      //   sortable: true,
      //   hide: true
      // },
      {
        headerName: "Steering Wheel Configuration",
        field: "steeringWheelConfiguration",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Trade Area Code",
        field: "tradeAreaCode",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Vehical Type",
        field: "vehicalType",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      // {
      //   headerName: "Total Hours",
      //   field: "totalHours",
      //   filter: true,
      //   editable: false,
      //   sortable: true,
      // },
      // {
      //   headerName: "Remaining Hours",
      //   field: "remainingHours",
      //   filter: true,
      //   editable: false,
      //   sortable: true,
      // }
    ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }


  onCellClicked(e: any) {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list/myparameters', { id: e.data.id}]);

  }

  // getter for easy access to form fields
  get f() {
    return this.projectForm.controls;
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }     
  }

  private deleteGridRow(params: any) {
    this.projectService.deleteProject(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }
  editOpenModal() {
    this.modeAction = 2;
    this.projectForm.patchValue(this.selectedCheckboxData[0])
  }

  deleteProjectList() {
    this.projectService.deleteProject(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getProjectsData();
      this.selectedCheckboxData = []
      $('#closeModalDeleteProject').trigger("click");
    });
  }

  openMyParameters() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list/myparameters']);
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].projectName}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].projectName}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].projectName}`;
    }
  }

 

  getUsers() {
    this.userService.getUserDetailsList().subscribe((response: any) => {
      this.users = response;
    });
  }

  backToMyProject() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list/myproject']);
  }

}
